import { render } from "./DDropdown.vue?vue&type=template&id=20cb4e22"
import script from "./DDropdown.vue?vue&type=script&lang=js"
export * from "./DDropdown.vue?vue&type=script&lang=js"

import "./DDropdown.vue?vue&type=style&index=0&id=20cb4e22&lang=css"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__